import React, { useState } from 'react';
import { AGREEMENT_TEXT, GREEN_LIGHT, BLACK } from '../constants';
import { mono } from '../styles';
import { Btn, TextInput } from '../components/UI';

export default function Agreement({ ob, onUpdate }) {
  const [name, setName]         = useState(ob.signedBy || '');
  const [scrolled, setScrolled] = useState(false);

  if (ob.signed) {
    return (
      <div style={{ textAlign: 'center', padding: '30px 0' }}>
        <div style={{ width: 60, height: 60, background: GREEN_LIGHT, borderRadius: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontWeight: 800, fontSize: 18 }}>
          OK
        </div>
        <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>Agreement Signed</div>
        <div style={mono}>
          By <b style={{ color: BLACK }}>{ob.signedBy}</b> on {new Date(ob.signedAt).toLocaleDateString()}
        </div>
        <div style={{ marginTop: 18, padding: '12px 16px', background: '#f8f8f6', borderRadius: 10, display: 'inline-block', textAlign: 'left', fontSize: 12, color: '#555' }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Signature Record</div>
          <div>Signed by: {ob.signedBy}</div>
          <div>Time: {new Date(ob.signedAt).toLocaleString()}</div>
          <div>Method: Typed name e-signature</div>
        </div>
      </div>
    );
  }

  function handleScroll(e) {
    const el = e.target;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 30) setScrolled(true);
  }

  function sign() {
    const newDone = ob.completedSteps.includes('agreement')
      ? ob.completedSteps
      : [...ob.completedSteps, 'agreement'];
    onUpdate({ ...ob, signed: true, signedBy: name.trim(), signedAt: new Date().toISOString(), completedSteps: newDone });
  }

  return (
    <div>
      <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 12 }}>Service Agreement</div>
      <div
        onScroll={handleScroll}
        style={{
          background: '#f8f8f6', borderRadius: 10, padding: '16px 18px',
          height: 300, overflowY: 'auto', marginBottom: 14,
          fontSize: 12, lineHeight: 1.9, color: '#333', whiteSpace: 'pre-wrap',
          border: '1.5px solid #e0e0d8', fontFamily: 'Georgia, serif',
        }}
      >
        {AGREEMENT_TEXT}
      </div>
      {!scrolled && (
        <div style={{ ...mono, textAlign: 'center', marginBottom: 10 }}>
          Scroll to the bottom to unlock signing
        </div>
      )}
      <TextInput
        label="Type your full name to sign"
        value={name} onChange={e => setName(e.target.value)}
        ph="Your full legal name" readOnly={!scrolled}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 11, color: '#999' }}>Typing your name is a legally binding signature</div>
        <Btn dis={!scrolled || !name.trim()} onClick={sign}>Sign Agreement</Btn>
      </div>
    </div>
  );
}
